import { axios_base } from './axios_base';

const axios_runwayml = axios_base.create();

axios_runwayml.interceptors.request.use(
  config => {
    const token = process.env.VUE_APP_RUNWAYML_API_KEY;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default axios_runwayml; 